@if (this.documentTypeListItem$ | async; as documentTypes) {
  <form [formGroup]="this.form">
    <table
      class="table table-striped table-hover"
      formArrayName="documentTypes"
      >
      <tbody>
        @for (documentType of documentTypes; track documentType; let i = $index) {
          <tr
            [formGroupName]="i"
            (click)="addDocumentType(documentType.id)"
            >
            <td class="align-middle">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  [formControlName]="'checked'"
                  />
                </div>
              </td>
              <td>
                {{documentType.name }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </form>
  }
